export enum RegionUsageRestrictions {
  GOV_REGIONS_ONLY = 'GOV_REGIONS_ONLY',
  COMMERCIAL_FEDRAMP_REGIONS_ONLY = 'COMMERCIAL_FEDRAMP_REGIONS_ONLY',
  NONE = 'NONE',
}
